<div class="external" id="main">
  <div class="section" id="landing">
    <div class="content-body">
      <!-- <div class="content">
        <div class="title">
          <h1>{{ "landing.title" | translate }}</h1>
        </div>
        <div class="text">
          <p>{{ "landing.text" | translate }}</p>
        </div>
        <div class="image-container">
          <img alt="calendar" src="../../../assets/images/calendar.svg"/>
        </div>
      </div>
      <div class="buttons">
        <button (click)="goTo()" class="costa-button" type="button">
          {{ "landing.start" | translate }}
        </button>
      </div>
    </div> -->
      <div class="overlaySpinner">
        <div class="spinner-loading">
          <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>